<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>You suddenly appeared and I pulled you close, such a blubbering wreck as I kissed your nose, and later that day I wrote a letter to you, the contents of which I now haven’t a clue, but soon you will read for the year is near, my emotional writings to you my dear</p>
<p>Ellie,</p>
<p>Colourful lots xxx</p>
<p>To Lewey Lee, Squeezebox and Gibbs,</p>
<p>Just file this next to my CD, or you could even read it.</p>
<p>To Avril,</p>
<p>True, it’s not your cup of coffee, but give it a stir sometime, you never know…xx</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?a1b70e3a